module.exports = __webpack_public_path__ + "img/helipad.c4d28ddb.svg";